import React, { useState, useEffect, useRef } from 'react'

import AceEditor from 'react-ace'
import 'brace/theme/cobalt'
import 'brace/ext/searchbox'
import { Card, CardHeader } from '@mui/material'
import { useDataProvider } from 'react-admin'

// returns the first search term of a log query string containing AND / OR operators
function getFirstSearchTerm(search) {
    // Split on AND/OR (case-sensitive), parentheses, and surrounding whitespace
    const pattern = /\b(?:AND|OR)\b|\(|\)/
    const tokens = search
        .split(pattern)
        .map((t) => t.trim())
        .filter(Boolean)
    return tokens[0] ?? ''
}

export const LogField = ({ record, query, disableLogPolling }) => {
    const dataProvider = useDataProvider()
    const editorRef = useRef()
    const [content, setContent] = useState()

    const handleEditorLoad = (editor) => {
        editorRef.current = editor
    }

    const logCallback = (event) => {
        if (event.type === 'update') {
            setContent(event.payload)
        }
    }

    useEffect(() => {
        // subscribe to the log if the run is not completed
        if (!record.completedDate && !disableLogPolling) {
            dataProvider.subscribe(`runs/${record.id}/log`, logCallback)
            return () =>
                dataProvider.unsubscribe(`runs/${record.id}/log`, logCallback)
        } else {
            const getLog = async () => {
                const res = await dataProvider.GET_ONE_LOG('runs', {
                    id: record.id,
                })
                setContent(res.data)
            }
            getLog()
        }
    }, [record.id, record.completedDate, dataProvider, disableLogPolling])

    useEffect(() => {
        const findQuery = async () => {
            // if the query contains AND / OR operators, we remove them and just query for the first term
            editorRef.current.find(getFirstSearchTerm(query))
            editorRef.current.execCommand('find')
        }
        if (editorRef.current && query && content) {
            findQuery()
        }
    }, [editorRef, content, query])

    return (
        <Card>
            <CardHeader title={'Log'} />
            <AceEditor
                mode="text"
                value={content}
                theme="cobalt"
                name="logViewer"
                width="100%"
                height="500px"
                fontSize={12}
                lineHeight={19}
                readOnly={true}
                showPrintMargin={false}
                onLoad={handleEditorLoad}
            />
        </Card>
    )
}
